// The one time a questionnaire URL is on screen: the mail's fate first,
// then the link itself and an honest Copy - "Copied" only when the
// clipboard took it, a by-hand hint when it did not.

import { useState } from "react";
import type { IntakeLinkIssue } from "../api/intake";

const DELIVERY_TEXT: Record<string, string> = {
  sent: "The link was emailed.",
  queued: "The email is queued - copy the link too, in case it stalls.",
  not_delivered: "The email could not be sent - copy the link and pass it on yourself.",
};

export function IssuedLinkReveal({ issue, testId }: { issue: IntakeLinkIssue; testId: string }) {
  const [copied, setCopied] = useState<"no" | "yes" | "failed">("no");

  const copy = () => {
    try {
      navigator.clipboard.writeText(issue.url).then(
        () => setCopied("yes"),
        () => setCopied("failed"),
      );
    } catch {
      setCopied("failed");
    }
  };

  return (
    <div className="intake-resent">
      {issue.email && <p className="intake-prose">{DELIVERY_TEXT[issue.email.delivered]}</p>}
      <div className="intake-link-url" data-testid={testId}>
        {issue.url}
      </div>
      <div className="cc-form-actions">
        <button type="button" className="cc-btn-primary" onClick={copy}>
          {copied === "yes" ? "Copied" : "Copy link"}
        </button>
        {copied === "failed" && (
          <span className="cc-form-hint">
            Could not copy - select the link and copy it by hand.
          </span>
        )}
      </div>
    </div>
  );
}
